import React from 'react';
import { Route } from 'react-router-dom';
import Dashboard from '../../../Dashboards/Dashboard';
export default () => React.createElement(Route, { path: '/custody', component: Dashboard });
